var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call_svgrepo.com",
    clipPath: "url(#clip0_5318_6634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Phone-call",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21218 5.0407C3.21218 5.0407 3.90449 6.95147 5.6491 10.5792C5.6491 10.5792 5.6491 10.5792 5.6491 10.6069C7.42141 14.2345 8.5568 15.8684 8.5568 15.8684C9.71987 17.1145 11.6583 17.6684 13.7353 16.6715C14.8706 16.1176 14.6768 14.8161 13.6245 12.6561C12.6829 10.7176 11.6306 10.6622 10.9383 11.2715C10.7999 11.3822 10.3568 11.7976 10.3291 11.9361C10.3291 11.9361 9.91372 12.6284 8.33526 9.33301C6.7568 6.06531 7.39372 6.23147 7.39372 6.23147C7.50449 6.25916 8.11372 6.34224 8.27987 6.28685C9.16603 6.09301 9.88603 5.15147 8.86141 3.04685C7.8091 0.886852 6.92295 -0.0823786 5.78757 0.471468C4.07064 1.27454 2.96295 3.35147 3.21218 5.0407Z",
    stroke: "#6B6C6E",
    strokeWidth: 1.84615
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5318_6634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.d7a95b6692b73afc673c7cda8e40c2e7.svg";
export { ForwardRef as ReactComponent };